import { render } from "./LandingCmt.vue?vue&type=template&id=3820c144&scoped=true"
import script from "./LandingCmt.vue?vue&type=script&lang=js"
export * from "./LandingCmt.vue?vue&type=script&lang=js"

import "./LandingCmt.vue?vue&type=style&index=0&id=3820c144&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3820c144"]])

export default __exports__